import { render, staticRenderFns } from "./SearchFeedback.vue?vue&type=template&id=010f84bc&scoped=true&"
import script from "./SearchFeedback.vue?vue&type=script&lang=js&"
export * from "./SearchFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SearchFeedback.vue?vue&type=style&index=0&id=010f84bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f84bc",
  null
  
)

export default component.exports